import { useContext } from 'react'

import { SubMenuActionsContext } from '../context'

export function useSubMenuActions() {
  return useContext(SubMenuActionsContext)
}
